import React, { FC, Fragment } from "react";

import * as Styles from "../leasing-modal-hub.styled";

export const LeasingFactoryOrderModal: FC = () => {
  return (
    <Fragment>
      <Styles.LeasingProductModalHeaderAndParagraphContainer>
        <Styles.LeasingProductModalHeader>
          What is a factory order?
        </Styles.LeasingProductModalHeader>
        <Styles.LeasingProductModalParagraph>
          A factory order is when the car isn&apos;t quite ready to leave the
          factory right now. The car will be finished to the specification you
          choose, and will then be delivered to you directly from the
          manufacturer.
        </Styles.LeasingProductModalParagraph>
        <Styles.LeasingProductModalParagraph>
          This means your delivery time will be a little longer, but we promise
          it&apos;s worth the wait!
        </Styles.LeasingProductModalParagraph>
      </Styles.LeasingProductModalHeaderAndParagraphContainer>
      <Styles.LeasingProductModalHeaderAndParagraphContainer>
        <Styles.LeasingProductModalHeader>
          Want your car sooner?
        </Styles.LeasingProductModalHeader>
        <Styles.LeasingProductModalParagraph>
          If it&apos;s available, try selecting &lsquo;In-stock options
          only&rsquo; to see car options that are available for faster delivery
          (usually within 56 days).
        </Styles.LeasingProductModalParagraph>
        <Styles.LeasingProductModalParagraph>
          Prices for in-stock options tend to be lower, and delivery times are
          usually more accurate.
        </Styles.LeasingProductModalParagraph>
      </Styles.LeasingProductModalHeaderAndParagraphContainer>
    </Fragment>
  );
};
